import React from 'react';
import { Link } from 'react-router-dom';
import gotoIndiaImage from "../../assests/gotoindia.jpg";

function GoToIndia() {
  const paragraph = (text, key) => (
    <p
      key={key}
      style={{
        fontSize: "13px",
        lineHeight: "1.8",
        color: "#333",
        marginBottom: "1rem",
      }}
    >
      {text}
    </p>
  );

  return (
    <div
      style={{
        fontFamily: "'Georgia','Times New Roman',serif",
        background: "#fff",
        color: "#222",
      }}
    >
      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          padding: "0 1.5rem 4rem",
        }}
      >
        {/* Back Link */}
        <Link
          to="/"
          style={{
            fontSize: "13px",
            color: "#c47a1e",
            textDecoration: "none",
            display: "inline-block",
            margin: "1.5rem 0 0",
            userSelect: "none",
          }}
        >
          ← Back to Home
        </Link>

        {/* Heading */}
        <h1
          style={{
            fontFamily: "'Dancing Script','Brush Script MT',cursive",
            fontSize: "2.5rem",
            color: "#f68a3a",
            margin: "1rem 0 0.2rem",
            fontWeight: 700,
          }}
        >
          Go to India
        </h1>

        {/* Dots */}
        <div
          style={{
            display: "flex",
            gap: "4px",
            marginBottom: "2rem",
          }}
        >
          {[...Array(9)].map((_, i) => (
            <div
              key={i}
              style={{
                width: "6px",
                height: "6px",
                borderRadius: "50%",
                background: "#f68a3a",
              }}
            />
          ))}
        </div>

        {/* Image & Content */}
        <div
          style={{
            display: "flex",
            gap: "2rem",
            alignItems: "flex-start",
            flexWrap: "wrap",
            marginBottom: "3rem",
          }}
        >
          <div style={{ flex: "0 0 370px", maxWidth: "100%" }}>
            <img
              src={gotoIndiaImage}
              alt="Go To India"
              style={{
                width: "100%",
                maxWidth: "100%",
                height: "auto",
                objectFit: "cover",
                borderRadius: "4px",
                display: "block",
              }}
            />
          </div>

          <div
            style={{
              flex: 1,
              minWidth: "260px",
            }}
          >
            {paragraph(
              "We invite and welcome you to come and serve on a short-term vision trip at our campus in India! It'll take no time and see first-hand what you are invited to!"
            )}

            {paragraph(
              "You will have many ministry opportunities each day, based on your areas of gifting. You can visit the village church plants, teach in our seminary, teach in our school or children's home, work on the farm or kitchen, go to a medical camp with our doctors and team, work on any building maintenance, and many more opportunities. We will have a schedule for the team each day."
            )}

            {paragraph(
              "Most of the campus speaks English."
            )}

            {paragraph(
              "We look forward to meeting you in the field in the future!"
            )}
          </div>
        </div>

        {/* Contact Text */}
        <p
          style={{
            textAlign: "center",
            fontSize: "13px",
            color: "#333",
            marginBottom: "3rem",
          }}
        >
          Please contact us for more information.
        </p>

        {/* Contact Section */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "5rem",
            flexWrap: "wrap",
            textAlign: "center",
          }}
        >
          {/* Email */}
          <div>
            <a
              href="https://outlook.office.com/mail/deeplink/compose?to=cfimin@christforindia.org"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: "none",
                color: "inherit",
                cursor: "pointer",
                display: "inline-block",
              }}
              title="Click to open Outlook Web compose email"
            >
              <div
                style={{
                  fontSize: "2rem",
                  color: "#f68a3a",
                  marginBottom: "0.8rem",
                  transition: "transform 0.2s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
              >
                📧
              </div>

              <p
                style={{
                  fontSize: "12px",
                  margin: 0,
                  color: "#333",
                  fontWeight: "600",
                }}
              >
                cfimin@christforindia.org
              </p>
            </a>
          </div>

          {/* Address */}
          <div>
            <div
              style={{
                fontSize: "2rem",
                color: "#f68a3a",
                marginBottom: "0.8rem",
              }}
            >
              ✉️
            </div>

            <p
              style={{
                fontSize: "12px",
                margin: 0,
                color: "#333",
              }}
            >
              P.O. Box 271086
            </p>

            <p
              style={{
                fontSize: "12px",
                margin: 0,
                color: "#333",
              }}
            >
              Dallas, TX 75227
            </p>
          </div>

          {/* Phone */}
          <div>
            <div
              style={{
                fontSize: "2rem",
                color: "#f68a3a",
                marginBottom: "0.8rem",
              }}
            >
              📞
            </div>

            <p
              style={{
                fontSize: "12px",
                margin: 0,
                color: "#333",
              }}
            >
              +1 (800) 943-0380
            </p>

            <p
              style={{
                fontSize: "12px",
                margin: 0,
                color: "#333",
              }}
            >
              +1 (972) 771-7221
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GoToIndia;
